import InlineEditController from "./inline_edit_controller"

// Reuse the compact inline editor. An unsaved household size cannot answer the old income question.
export default class extends InlineEditController {
  static targets = ["display", "form", "choices"]

  edit() {
    super.edit()
    this.choicesTarget.hidden = true
    this.formTarget.querySelector("input[type=number]")?.focus()
  }

  cancel() {
    super.cancel()
    this.choicesTarget.hidden = false
    this.displayTarget.querySelector("button")?.focus()
  }
}
